export const CONTENT_TYPE_OPTIONS = [
  { value: "video", label: "Video" },
  { value: "image_text", label: "Image + Text" },
  { value: "audio_text", label: "Audio + Text" },
];

export const CONTENT_TYPE_LABELS = {
  video: "Video",
  image_text: "Image + Text",
  audio_text: "Audio + Text",
};

export const getContentTypeLabel = (type) =>
  CONTENT_TYPE_LABELS[type] || "Video";
